_ = require 'underscore'

_.mixin
  # Loop over objects, applying a transformation function to each key and value
  # and returning a new object consisting of the transformed keys/values
  # Example: mapObj { a: 1 }, (val, key) -> ["new_#{key}", val + 2]
  #          === { new_a: 3 }
  mapObj: _.compose(_.object, _.map)

  count: (array, predicate = (-> true)) ->
    count = 0
    for obj in array when predicate(obj)
      count++
    count
